/* eslint-disable no-unused-vars */
/* eslint-disable no-return-assign */
import axios from 'axios';


const apiUrl = process.env.REACT_APP_API_HOTSEARCH;


const hotSearchWithProductAndExchange = async (queryString)=> {

  // NB: do NOT encodeURI here - the keyword goes in a JSON body, so spaces were arriving as "%20"
  // and every multi-word override search (e.g. "Eurasia Research") returned nothing.
  queryString = (queryString || '').trim();
  
  const searchData = {
      "keyword": queryString
  };

   return axios.post(
      apiUrl,
      searchData,
      {headers: {
        'Content-Type' : 'application/json;charset=UTF-8',
        'Accept' : 'application/json',
        "Access-Control-Allow-Origin": "*"
        },
      }
    ).then(response => {
      //console.log(response.data.productResults);
      //console.log(response.data.exchangeResults);
      return {
        'products': response.data.productResults.results,
        'exchanges': response.data.exchangeResults.results
      };
   
    })
    .catch(error => {
        console.error('Error:', error);
    });
  
}


const service = {
  hotSearchWithProductAndExchange,
};
export default service;

